import Component from './component.vue';

export * from './types';

export default Component;




// WEBPACK FOOTER //
// ./src/presets/button/can-request/index.ts